import { Inject, Injectable } from '@angular/core';
import { SessionService as AuthSessionService, IAppState } from '@auth/auth';
import { User, UserAttributes } from '@auth/auth/lib/models/user';
import { Observable, of, ReplaySubject, switchMap } from 'rxjs';
import { EventType } from '../../enums/enums/event-type';
import { ShellService } from '../shell.service';
import { UserService } from '../user/user.service';
import { UserecoApiService } from '../usereco-api.service';

@Injectable({
  providedIn: 'root'
})
export class ShellLoggingService {
  private readonly shellUser$ = new ReplaySubject<User>();

  constructor(
    @Inject('ShellService') private shellService: ShellService,
    private userService: UserService,
    private readonly userecoApiService: UserecoApiService,
    private readonly sessionService: AuthSessionService<IAppState>
  ) {}

  setShellUser(user: {
    userAttributes: Record<string, UserAttributes[]>;
  }): void {
    this.shellService.changeUserAttributes(user);
    this.shellUser$.next(user);
  }

  getUser(): Observable<User> {
    return navigator.serviceWorker
      ? this.userService
          .getUser()
          .pipe(switchMap((user) => (user ? of(user) : this.shellUser$)))
      : this.shellUser$;
  }

  log(
    eventType: EventType,
    message: string,
    eventData?: unknown,
    error?: Error
  ): ReturnType<AuthSessionService['logToDatabase']> {
    const request = this.userecoApiService.createLogRequest(
      eventType,
      message,
      eventData,
      error
    );

    // We need to call logToDatabase from the auth library instead of calling userecoapi service log method
    // since the former will handle the response of the log endpoint
    return this.sessionService.logToDatabase(request);
  }
}
